module.exports = __webpack_public_path__ + "img/header_hospital.2330bee6.png";